module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "newsForm",
    attrs: {
      "model": _vm.newsData,
      "rules": _vm.validateRules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "标题",
      "prop": "newsContentTitle"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "placeholder": "直播标题（必填）"
    },
    model: {
      value: (_vm.newsData.newsContentTitle),
      callback: function($$v) {
        _vm.newsData.newsContentTitle = $$v
      },
      expression: "newsData.newsContentTitle"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "来源",
      "prop": "newsContentSource"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "placeholder": "直播来源（必填）"
    },
    model: {
      value: (_vm.newsData.newsContentSource),
      callback: function($$v) {
        _vm.newsData.newsContentSource = $$v
      },
      expression: "newsData.newsContentSource"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "链接",
      "prop": "newsContentURL"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "placeholder": "直播链接（必填）"
    },
    model: {
      value: (_vm.newsData.newsContentURL),
      callback: function($$v) {
        _vm.newsData.newsContentURL = $$v
      },
      expression: "newsData.newsContentURL"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "yd-zhibo-long-words",
    staticStyle: {
      "margin-bottom": "22px"
    },
    attrs: {
      "label": "封皮图片（尺寸16:9）",
      "prop": "newsContentImage"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "placeholder": "图片链接（必填）"
    },
    model: {
      value: (_vm.newsData.newsContentImage),
      callback: function($$v) {
        _vm.newsData.newsContentImage = $$v
      },
      expression: "newsData.newsContentImage"
    }
  })], 1), _vm._v(" "), (_vm.isEdit) ? _c('el-form-item', {
    attrs: {
      "label": "置顶权重",
      "prop": "newsContentIsTop"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.newsData.newsContentIsTop),
      callback: function($$v) {
        _vm.newsData.newsContentIsTop = $$v
      },
      expression: "newsData.newsContentIsTop"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', [_c('el-button-group', [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.newsFormSubmit
    }
  }, [_vm._v("提交")]), _vm._v(" "), (_vm.addForm) ? _c('el-button', {
    on: {
      "click": _vm.newsFormReset
    }
  }, [_vm._v("重置")]) : _c('el-button', {
    on: {
      "click": _vm.newsFormCancle
    }
  }, [_vm._v("取消")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-d63ca204"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/market/common/newsAddForm/LiveNews.vue
// module id = 795
// module chunks = 1